// Firebase app init — mirrors collaborative/collaborative_react/src/database/firebase.js.
// Realtime Database only (no Firestore needed here); no Firebase Authentication on purpose —
// set the RTDB rules for the "session" path to public read/write, e.g.:
//   { "rules": { "session": { ".read": true, ".write": true } } }
import { initializeApp, getApps } from "firebase/app";

function resolveDatabaseUrl() {
  const fromEnv = process.env.REACT_APP_FIREBASE_DATABASE_URL;
  if (fromEnv && String(fromEnv).trim()) return String(fromEnv).trim();
  const projectId = process.env.REACT_APP_FIREBASE_PROJECT_ID;
  if (projectId) return `https://${projectId}-default-rtdb.firebaseio.com`;
  return null;
}

export function getFirebaseApp() {
  const databaseURL = resolveDatabaseUrl();
  if (!databaseURL) return null;
  if (getApps().length > 0) return getApps()[0];
  return initializeApp({
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    databaseURL,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
  });
}

export function isFirebaseConfigured() {
  return Boolean(resolveDatabaseUrl() && process.env.REACT_APP_FIREBASE_API_KEY);
}
